var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectButtonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0251 8.83724L13.2333 14.3807C13.0948 15.3502 12.2519 16.0811 11.2727 16.0811H5.5579C4.90549 16.0811 4.29547 15.7602 3.92589 15.2225L0.414104 10.1145C0.0896832 9.64235 0.148111 9.00579 0.553141 8.60096L1.11147 8.04263C1.57493 7.57917 2.32854 7.57917 2.7918 8.04263L4.32835 9.57917V1.42468C4.32835 0.769305 4.86132 0.236328 5.5167 0.236328H6.02532C6.61613 0.236328 7.11009 0.660175 7.19981 1.24405L7.84865 5.46152L12.5448 6.63562C13.5329 6.8826 14.1693 7.82892 14.0251 8.83724Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectButtonActive);
export default __webpack_public_path__ + "static/media/object_button_active.357081a3300da739b453640bbf0d0c90.svg";
export { ForwardRef as ReactComponent };